
import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_SECURITY}`

export default () => http.get(`${api}/permissions`)
